export enum MediaCommunication {
    NEWS = 'news',
    INSTRUCTION = 'instruction',
}
